import { LoginComponent } from "fwork.react.apptemplate/src/components/auth/login"
import React from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { RoutesNames, onLoginPayloadOverride } from "../../globals"
import { IDotEnvProductionState } from "../../redux/reducers/dotenvProduction.slice"
import { RootState } from "../../redux/store"

export const Login = () => {
  const dotEnvProductionState: IDotEnvProductionState = useSelector((state: RootState) => state.dotEnvProductionState)
  const navigate = useNavigate()

  return <LoginComponent
    apiUrl={`${dotEnvProductionState.payload?.APIURL}/auth`}
    onPayloadOverride={onLoginPayloadOverride}
    onSuccess={() => navigate(RoutesNames.home)}
  />
}